function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { isScaleChannel } from '../../channel';
import { vgField as fieldRef } from '../../channeldef';
import { hash as _hash, keys } from '../../util';
import { getScaleInvalidDataMode } from '../invalid/ScaleInvalidDataMode';
import { DataFlowNode } from './dataflow';
import { isCountingAggregateOp } from '../../aggregate';
export var FilterInvalidNode = /*#__PURE__*/function (_DataFlowNode) {
  function FilterInvalidNode(parent, filter) {
    var _this;
    _classCallCheck(this, FilterInvalidNode);
    _this = _callSuper(this, FilterInvalidNode, [parent]);
    _this.filter = filter;
    return _this;
  }
  _inherits(FilterInvalidNode, _DataFlowNode);
  return _createClass(FilterInvalidNode, [{
    key: "clone",
    value: function clone() {
      return new FilterInvalidNode(null, _objectSpread({}, this.filter));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(keys(this.filter));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(); // filter does not produce any new fields
    }
  }, {
    key: "hash",
    value: function hash() {
      return "FilterInvalid ".concat(_hash(this.filter));
    }
    /**
     * Create the VgTransforms for each of the filtered fields.
     */
  }, {
    key: "assemble",
    value: function assemble() {
      var _this2 = this;
      var filters = keys(this.filter).reduce(function (vegaFilters, field) {
        var fieldDef = _this2.filter[field];
        var ref = fieldRef(fieldDef, {
          expr: 'datum'
        });
        if (fieldDef !== null) {
          if (fieldDef.type === 'temporal') {
            vegaFilters.push("(isDate(".concat(ref, ") || (").concat(isValidFiniteNumberExpr(ref), "))"));
          } else if (fieldDef.type === 'quantitative') {
            vegaFilters.push(isValidFiniteNumberExpr(ref));
          } else {
            // should never get here
          }
        }
        return vegaFilters;
      }, []);
      return filters.length > 0 ? {
        type: 'filter',
        expr: filters.join(' && ')
      } : null;
    }
  }], [{
    key: "make",
    value: function make(parent, model, dataSourcesForHandlingInvalidValues) {
      var config = model.config,
        markDef = model.markDef;
      var marks = dataSourcesForHandlingInvalidValues.marks,
        scales = dataSourcesForHandlingInvalidValues.scales;
      if (marks === 'include-invalid-values' && scales === 'include-invalid-values') {
        // If neither marks nor scale domains need data source to filter null values, then don't add the filter.
        return null;
      }
      var filter = model.reduceFieldDef(function (aggregator, fieldDef, channel) {
        var scaleComponent = isScaleChannel(channel) && model.getScaleComponent(channel);
        if (scaleComponent) {
          var scaleType = scaleComponent.get('type');
          var aggregate = fieldDef.aggregate;
          var invalidDataMode = getScaleInvalidDataMode({
            scaleChannel: channel,
            markDef: markDef,
            config: config,
            scaleType: scaleType,
            isCountAggregate: isCountingAggregateOp(aggregate)
          });
          // If the invalid data mode is include or always-valid, we don't need to filter invalid values as the scale can handle invalid values.
          if (invalidDataMode !== 'show' && invalidDataMode !== 'always-valid') {
            aggregator[fieldDef.field] = fieldDef; // we know that the fieldDef is a typed field def
          }
        }
        return aggregator;
      }, {});
      if (!keys(filter).length) {
        return null;
      }
      return new FilterInvalidNode(parent, filter);
    }
  }]);
}(DataFlowNode);
export function isValidFiniteNumberExpr(ref) {
  return "isValid(".concat(ref, ") && isFinite(+").concat(ref, ")");
}